'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

// import style from './HostCarriersTable.scss';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _HostCarriersTable = require('./HostCarriersTable.css');

var _HostCarriersTable2 = _interopRequireDefault(_HostCarriersTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HostCarriersTable = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HostCarriersTable, _Component);

  function HostCarriersTable(props) {
    (0, _classCallCheck3.default)(this, HostCarriersTable);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HostCarriersTable.__proto__ || (0, _getPrototypeOf2.default)(HostCarriersTable)).call(this, props));

    _this._existFormatSelected = function (ruleId) {
      var rules = _this.props.rules;
      var selectedRules = rules.selectedRules;

      var exist = false;

      for (var i = 0; i < selectedRules.length; i++) {
        if (selectedRules[i] && selectedRules[i].tqRuleCategoryIdFky && selectedRules[i].tqRuleCategoryIdFky === ruleId) {
          exist = true;
          break;
        }
      }

      return exist;
    };

    _this._isCheckboxChecked = function (ruleId) {
      var rules = _this.props.rules;
      var selectedRules = rules.selectedRules;

      var isChecked = false;
      for (var i = 0; i < selectedRules.length; i++) {
        if (selectedRules[i] && selectedRules[i].tqRuleCategoryIdFky && selectedRules[i].tqRuleCategoryIdFky === ruleId) {
          isChecked = selectedRules[i].include || false;
          break;
        }
      }
      return isChecked;
    };

    _this._isRadioChecked = function (ruleId, formatId) {
      var rules = _this.props.rules;
      var selectedRules = rules.selectedRules;

      var isChecked = false;
      for (var i = 0; i < selectedRules.length; i++) {
        if (selectedRules[i] && selectedRules[i].tqRuleCategoryIdFky && selectedRules[i].tqRuleCategoryIdFky === ruleId) {
          isChecked = selectedRules[i].tqRuleFormatIdFky && selectedRules[i].tqRuleFormatIdFky === formatId;
          break;
        }
      }
      return isChecked;
    };

    _this._renderHeader = function () {
      var rules = _this.props.rules;


      return rules && rules.rulesFormat && rules.rulesFormat.map(function (rule) {
        return _react2.default.createElement(
          'th',
          {
            key: 'tq-plus-admin-header' + rule.description,
            id: rule.description,
            className: _HostCarriersTable2.default.selectionCol
          },
          rule.description
        );
      }) || null;
    };

    _this._handleCheckBox = function (element) {
      var onChangeInclude = _this.props.onChangeInclude;


      if (typeof onChangeInclude === 'function') {
        onChangeInclude(Number(element.target.id), element.target.checked);
      }
    };

    _this._handleRadioButton = function (element) {
      var onChangeFormat = _this.props.onChangeFormat;
      // const formatName = element.target.dataset.formatname;
      // const ruleName = element.target.dataset.rulename;

      var formatId = Number(element.target.getAttribute('data-format-id'));
      var ruleId = Number(element.target.getAttribute('data-rule-id'));

      if (typeof onChangeFormat === 'function') {
        onChangeFormat(formatId, ruleId);
      }
    };

    _this._renderFormatColumn = function (ruleId) {
      var rules = _this.props.rules;


      return rules.rulesFormat.map(function (format) {
        return _react2.default.createElement(
          'td',
          { key: 'tq-plus-admin-header' + format.description,
            id: format.description,
            style: { textAlign: 'center' }
          },
          _react2.default.createElement('input', { 'data-rule-id': ruleId.toString(),
            'data-format-id': format.id.toString(),
            id: format.id,
            type: 'radio',
            onChange: _this._handleRadioButton,
            checked: _this._isRadioChecked(ruleId, Number(format.id))
          })
        );
      });
    };

    _this._renderBody = function () {
      var rules = _this.props.rules;


      return rules && rules.rules && rules.rules.map(function (rule) {
        return _react2.default.createElement(
          'tr',
          { key: 'tq-plus-admin-body' + rule.number },
          _react2.default.createElement(
            'td',
            null,
            rule.number + ' ' + rule.name
          ),
          _react2.default.createElement(
            'td',
            { style: { textAlign: 'center' } },
            _react2.default.createElement('input', { id: rule.id.toString(),
              type: 'checkbox',
              onChange: _this._handleCheckBox,
              checked: _this._isCheckboxChecked(rule.id),
              disabled: !_this._existFormatSelected(rule.id)
            })
          ),
          _this._renderFormatColumn(rule.id)
        );
      }) || null;
    };

    _this._existFormatSelected = _this._existFormatSelected.bind(_this);
    _this._isCheckboxChecked = _this._isCheckboxChecked.bind(_this);
    _this._isRadioChecked = _this._isRadioChecked.bind(_this);
    _this._renderHeader = _this._renderHeader.bind(_this);
    _this._handleCheckBox = _this._handleCheckBox.bind(_this);
    _this._handleRadioButton = _this._handleRadioButton.bind(_this);
    _this._renderFormatColumn = _this._renderFormatColumn.bind(_this);
    _this._renderBody = _this._renderBody.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(HostCarriersTable, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var saveState = this.props.saveState;


      if (typeof saveState === 'function') {
        saveState();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var rules = this.props.rules;

      return _react2.default.createElement(
        'div',
        { className: _HostCarriersTable2.default.root },
        _react2.default.createElement(
          'table',
          { className: _HostCarriersTable2.default.theTable },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { className: _HostCarriersTable2.default.categoryCol },
                'Category'
              ),
              _react2.default.createElement(
                'th',
                { className: _HostCarriersTable2.default.selectionCol },
                'Include'
              ),
              this._renderHeader()
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            this._renderBody()
          )
        )
      );
    }
  }]);
  return HostCarriersTable;
}(_react.Component), _class.propTypes = {
  rules: _react.PropTypes.object,
  onChangeInclude: _react.PropTypes.func,
  onChangeFormat: _react.PropTypes.func,
  saveState: _react.PropTypes.func
}, _temp);
exports.default = HostCarriersTable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Rules/Components/HostCarriersTable/HostCarriersTable.jsx
// module id = 1462
// module chunks = 0